import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import BrandAiChat from "./components/feature/BrandAiChat";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import SiteLocaleTranslator from "./components/feature/SiteLocaleTranslator";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <SiteLocaleTranslator />
        <ScrollToTop />
        <AppRoutes />
        <BrandAiChat brandName="山頂視角" siteUrl="https://peakview.sonbook.net" />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
